import { getMonth, parse, getYear, addYears, format } from 'date-fns';

var COLUMN_SIZE = 3;
var useMonthPicker = function useMonthPicker(props) {
  var startDate = props.startDate,
    endDate = props.endDate,
    calendarMonth = props.calendarMonth,
    onCalendarChange = props.onCalendarChange,
    locale = props.locale,
    onMonthChange = props.onMonthChange,
    onYearChange = props.onYearChange,
    calendarYear = props.calendarYear,
    containerGridRef = props.containerGridRef,
    nextButtonProps = props.nextButton,
    prevButtonProps = props.prevButton;
  var getActiveId = function getActiveId(activeElement) {
    if (!activeElement) return 0;
    var value = activeElement.children[0].innerHTML;
    var activeId = getMonth(parse(value, 'LLL', new Date()));
    return activeId;
  };
  var onHeaderKeydown = function onHeaderKeydown(e) {
    var activeElement = document.activeElement;
    var calendarHeader = activeElement.closest('#calendar-header');
    var prevNavButton = calendarHeader === null || calendarHeader === void 0 ? void 0 : calendarHeader.querySelector('#previous-month-nav');
    var nextNavButton = calendarHeader === null || calendarHeader === void 0 ? void 0 : calendarHeader.querySelector('#next-month-nav');
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      if (prevNavButton.disabled) return;
      prevNavButton.focus();
    }
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      if (nextNavButton !== null && nextNavButton !== void 0 && nextNavButton.disabled) return;
      nextNavButton.focus();
    }
    if (e.key === 'ArrowDown') {
      var _containerGridRef$cur;
      e.preventDefault();
      containerGridRef === null || containerGridRef === void 0 || (_containerGridRef$cur = containerGridRef.current) === null || _containerGridRef$cur === void 0 || (_containerGridRef$cur = _containerGridRef$cur.querySelector('button[tabIndex="0"]')) === null || _containerGridRef$cur === void 0 || _containerGridRef$cur.focus();
    }
  };
  var onKeyDown = function onKeyDown(e) {
    if (e.key === 'ArrowLeft') {
      if (containerGridRef !== null && containerGridRef !== void 0 && containerGridRef.current) {
        var _containerGridRef$cur2;
        e.preventDefault();
        var buttons = containerGridRef === null || containerGridRef === void 0 || (_containerGridRef$cur2 = containerGridRef.current) === null || _containerGridRef$cur2 === void 0 ? void 0 : _containerGridRef$cur2.querySelectorAll('button');
        var activeId = getActiveId(document.activeElement);
        var nextId = activeId - 1;
        var nextButton = buttons === null || buttons === void 0 ? void 0 : buttons[nextId];
        if (nextButton && nextButton.getAttribute('disabled') === null) {
          nextButton.focus();
        } else if (!nextButton) {
          if (startDate && getYear(startDate) >= getYear(calendarYear)) return;
          var nextYear = addYears(calendarYear, -1);
          onYearChange(nextYear);
          var a = 11;
          buttons === null || buttons === void 0 || buttons[a].focus();
        }
      }
    }
    if (e.key === 'ArrowRight') {
      if (containerGridRef !== null && containerGridRef !== void 0 && containerGridRef.current) {
        var _containerGridRef$cur3;
        e.preventDefault();
        var _buttons = containerGridRef === null || containerGridRef === void 0 || (_containerGridRef$cur3 = containerGridRef.current) === null || _containerGridRef$cur3 === void 0 ? void 0 : _containerGridRef$cur3.querySelectorAll('button');
        var _activeId = getActiveId(document.activeElement);
        var _nextId = _activeId + 1;
        var _nextButton = _buttons === null || _buttons === void 0 ? void 0 : _buttons[_nextId];
        if (_nextButton && _nextButton.getAttribute('disabled') === null) {
          _nextButton.focus();
        } else if (!_nextButton) {
          if (endDate && getYear(endDate) <= getYear(calendarYear)) return;
          var _nextYear = addYears(calendarYear, 1);
          onYearChange(_nextYear);
          var _a = 0;
          _buttons === null || _buttons === void 0 || _buttons[_a].focus();
        }
      }
    }
    if (e.key === 'ArrowUp') {
      if (containerGridRef !== null && containerGridRef !== void 0 && containerGridRef.current) {
        var _containerGridRef$cur4;
        e.preventDefault();
        var _buttons2 = containerGridRef === null || containerGridRef === void 0 || (_containerGridRef$cur4 = containerGridRef.current) === null || _containerGridRef$cur4 === void 0 ? void 0 : _containerGridRef$cur4.querySelectorAll('button');
        var _activeId2 = getActiveId(document.activeElement);
        var _nextId2 = _activeId2 - COLUMN_SIZE;
        var _nextButton2 = _buttons2 === null || _buttons2 === void 0 ? void 0 : _buttons2[_nextId2];
        if (_nextButton2 && _nextButton2.getAttribute('disabled') === null) {
          _nextButton2.focus();
        } else if (!_nextButton2) {
          if (startDate && getYear(startDate) >= getYear(calendarYear)) return;
          var _nextYear2 = addYears(calendarYear, -1);
          onYearChange(_nextYear2);
          var _a2 = _nextId2 + COLUMN_SIZE + 9;
          _buttons2 === null || _buttons2 === void 0 || _buttons2[_a2].focus();
        }
      }
    }
    if (e.key === 'ArrowDown') {
      if (containerGridRef !== null && containerGridRef !== void 0 && containerGridRef.current) {
        var _containerGridRef$cur5;
        e.preventDefault();
        var _buttons3 = containerGridRef === null || containerGridRef === void 0 || (_containerGridRef$cur5 = containerGridRef.current) === null || _containerGridRef$cur5 === void 0 ? void 0 : _containerGridRef$cur5.querySelectorAll('button');
        var _activeId3 = getActiveId(document.activeElement);
        var _nextId3 = _activeId3 + COLUMN_SIZE;
        var _nextButton3 = _buttons3 === null || _buttons3 === void 0 ? void 0 : _buttons3[_nextId3];
        if (_nextButton3 && _nextButton3.getAttribute('disabled') === null) {
          _nextButton3.focus();
        } else if (!_nextButton3) {
          if (endDate && getYear(endDate) <= getYear(calendarYear)) return;
          var _nextYear3 = addYears(calendarYear, 1);
          onYearChange(_nextYear3);
          var _a3 = _nextId3 % COLUMN_SIZE;
          _buttons3 === null || _buttons3 === void 0 || _buttons3[_a3].focus();
        }
      }
    }
  };
  var getButtonCellProps = function getButtonCellProps(monthCount) {
    var startMonth = startDate && getYear(calendarYear) === getYear(startDate) ? getMonth(startDate) : undefined;
    var endMonth = endDate && getYear(calendarYear) === getYear(endDate) ? getMonth(endDate) : undefined;
    var monthLabel = format(new Date(getYear(calendarYear), monthCount, 1), 'LLL', {
      locale: locale
    });
    var isDisabled = !!startMonth && monthCount < startMonth || !!endMonth && monthCount > endMonth;
    var isSelected = !isDisabled && getYear(calendarYear) === getYear(calendarMonth) && monthCount === getMonth(calendarYear);
    var getTabIndex = function getTabIndex() {
      if (isDisabled) return -1;
      if (isSelected) return 0;
      if (getYear(calendarYear) !== getYear(calendarMonth) && startMonth && monthCount === startMonth) return 0;
      if (getYear(calendarYear) !== getYear(calendarMonth) && monthCount === 0) return 0;
      return -1;
    };
    return {
      onKeyDown: onKeyDown,
      key: monthLabel,
      disabled: isDisabled,
      selected: isSelected,
      label: monthLabel,
      tabIndex: getTabIndex(),
      onClick: function onClick() {
        if (isDisabled) return;
        onMonthChange(new Date(getYear(calendarYear), monthCount, 1));
        onCalendarChange('day');
      }
    };
  };
  var calendarHeaderProps = {
    prevButton: {
      icon: 'fill.arrow.dbl-left',
      onClick: function onClick() {
        var prevYear = addYears(calendarYear, -1);
        onYearChange(prevYear);
      },
      'aria-label': (prevButtonProps === null || prevButtonProps === void 0 ? void 0 : prevButtonProps['aria-label']) || '',
      disabled: startDate && getYear(startDate) >= getYear(calendarYear)
    },
    nextButton: {
      icon: 'fill.arrow.dbl-right',
      onClick: function onClick() {
        var nextYear = addYears(calendarYear, 1);
        onYearChange(nextYear);
      },
      'aria-label': (nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps['aria-label']) || '',
      disabled: endDate && getYear(endDate) <= getYear(calendarYear)
    },
    onKeyDown: onHeaderKeydown
  };
  return {
    getButtonCellProps: getButtonCellProps,
    calendarHeaderProps: calendarHeaderProps
  };
};

export { useMonthPicker };
//# sourceMappingURL=useMonthPicker.js.map
